import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/tab-row/tab-row.js';
      import {TabData} from '@oicl/openbridge-webcomponents/dist/components/tab-row/tab-row.js';

      export interface Props {
     tabs?: TabData[];
     selectedTabId?: string;
     hasClose?: boolean;
     hug?: boolean;
     hasAddNewTab?: boolean
   }

      
  
      export type {TabData} from '@oicl/openbridge-webcomponents/dist/components/tab-row/tab-row.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcTabRow',
  props: {
    tabs: {},
    selectedTabId: {},
    hasClose: { type: Boolean },
    hug: { type: Boolean },
    hasAddNewTab: { type: Boolean }
  },
  emits: ["tab-selected", "tab-closed", "add-new-tab"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onTabSelected: (event: CustomEvent<{tab: TabData, id: string, index: number}>) => emit('tab-selected', event as CustomEvent<{tab: TabData, id: string, index: number}>),
onTabClosed: (event: CustomEvent<{tab: TabData, id: string, index: number}>) => emit('tab-closed', event as CustomEvent<{tab: TabData, id: string, index: number}>),
onAddNewTab: (event: CustomEvent<void>) => emit('add-new-tab', event as CustomEvent<void>)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-tab-row',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})